import { ChapterMark, FadeIn } from '../components/eclora/Reveal';

const LINES = [
    'Une habitude à changer.',
    'Un projet à commencer.',
    'Du temps à reprendre pour toi.',
    'Une envie que tu repousses.',
    'Ou simplement cette sensation que la femme que tu deviens mérite une vie qui lui ressemble davantage.',
];

export default function Identification() {
    return (
        <section className="px-6 py-20 sm:px-10 lg:py-32" data-testid="identification-section">
            <div className="mx-auto max-w-3xl text-center">
                <ChapterMark index="01" label="L'appel" />
                <FadeIn>
                    <h2 className="font-serif text-3xl font-medium leading-tight text-bordeaux sm:text-4xl lg:text-5xl">
                        Peut-être que tu n'as pas besoin de tout changer.
                    </h2>
                </FadeIn>
                <FadeIn delay={0.15}>
                    <p className="mt-6 font-script text-3xl leading-snug text-champagne sm:text-4xl" data-testid="identification-script">
                        Peut-être que tu as simplement besoin de commencer.
                    </p>
                </FadeIn>
                <FadeIn delay={0.25}>
                    <p className="mx-auto mt-10 max-w-xl text-base leading-relaxed text-cacao/90 sm:text-lg">
                        Ta vie ne va peut-être pas mal.
                        <br />
                        Mais au fond de toi, tu sens qu'une nouvelle étape t'appelle.
                    </p>
                </FadeIn>

                <div className="mx-auto mt-10 max-w-xl space-y-1 border-y border-champagne/30 py-6" data-testid="manifesto-text">
                    {LINES.map((line, i) => (
                        <FadeIn key={line} delay={0.08 * i} y={16}>
                            <p className={`py-2 font-serif text-lg sm:text-xl ${i === LINES.length - 1 ? 'text-serifit text-bordeaux' : 'text-cacao/85'}`}>
                                {line}
                            </p>
                        </FadeIn>
                    ))}
                </div>

                <FadeIn delay={0.3}>
                    <p className="mt-10 text-serifit text-xl text-bordeaux sm:text-2xl">
                        C'est exactement pour cela que j'ai créé Reset Éclora.
                    </p>
                </FadeIn>
            </div>
        </section>
    );
}
